import { paths } from '@/config/paths'
import { OpenDialogFunction } from '@/domain/hooks/useDialog'
import { LinkButton } from '@/ui/atoms/button/Button'
import { LegacyMarketBanner } from '@/ui/molecules/legacy-market-banner/LegacyMarketBanner'
import { ArrowRightIcon, Info } from 'lucide-react'
import { IsolatedMigrationWorkspace } from '../components/migration-workspace/IsolatedMigrationWorkspace'
import { MyBorrowsTable } from '../components/my-borrows-table/MyBorrowsTable'
import { MyDepositsTable } from '../components/my-deposit-table/MyDepositsTable'
import { Borrow, Deposit } from '../logic/useMyPortfolio'
export interface PositionViewProps {
  deposits: Deposit[]
  borrows: Borrow[]
  openDialog: OpenDialogFunction
}

export function PositionView({ deposits, borrows, openDialog }: PositionViewProps) {
  const hasPositions = deposits.length > 0 || borrows.length > 0

  return (
    <div className="flex flex-col">
      {!hasPositions && (
        <div className="mb-4">
          <EmptyLegacyPositionsBanner />
        </div>
      )}
      {hasPositions && <LegacyMarketBanner className="mb-4" showExploreLink={false} />}
      <IsolatedMigrationWorkspace deposits={deposits} borrows={borrows} />
      {hasPositions && (
        <div className="flex flex-col gap-4 xl:flex-row">
          <div className="flex-1">
            <MyDepositsTable assets={deposits} openDialog={openDialog} />
          </div>
          <div className="flex-1">
            <MyBorrowsTable assets={borrows} openDialog={openDialog} />
          </div>
        </div>
      )}
    </div>
  )
}

function EmptyLegacyPositionsBanner() {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-blue-500/20 bg-blue-500/5 p-4 md:p-6">
      <div className="flex items-start gap-3">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-blue-400" />
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold text-foreground">Legacy Isolated Markets — Deprecated</h3>
          <p className="text-muted-foreground text-sm leading-relaxed">
            These isolated markets are deprecated and no new borrows are available. Use HypurrFi&apos;s active markets
            for new lending and borrowing positions.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 pl-8 sm:gap-3">
        <LinkButton href={paths.earn} variant="outline" size="sm" postfixIcon={<ArrowRightIcon className="h-4 w-4" />}>
          Explore Markets
        </LinkButton>
      </div>
    </div>
  )
}
